enum Sections {
  switching = 'switching',
  speeds = 'speeds',
  landline = 'landline',
}

enum Topics {
  downloadAndUploadSpeeds = 'downloadAndUploadSpeeds',
  needForSpeed = 'needForSpeed',
  workOutAverageSpeed = 'workOutAverageSpeed',
  speedNotFastEnough = 'speedNotFastEnough',
  supportWithBroadband = 'supportWithBroadband',
  whenSwitchGoLive = 'whenSwitchGoLive',
  needToContactOldProvider = 'needToContactOldProvider',
  routerDelivery = 'routerDelivery',
  engineerVisit = 'engineerVisit',
  exitFees = 'exitFees',
  landlineCallPackage = 'landlineCallPackage',
  landlineSwitch = 'landlineSwitch',
}

export { Topics, Sections };
